import type { LayoutLoad } from './$types';

export const load: LayoutLoad = async ({ data }) => {
	const { etfQuote, mutualFundQuote, reitQuote, quote } = data;

	const response: typeof data & {
		etfQuote?: typeof etfQuote;
		mutualFundQuote?: typeof mutualFundQuote;
		reitQuote?: typeof reitQuote;
		quote?: typeof quote;
	} = {
		...data,
		etfQuote,
		mutualFundQuote,
		reitQuote,
		quote
	};

	return {
		...response,
		quoteData: etfQuote ?? mutualFundQuote ?? reitQuote ?? quote!,
		disableStickyHeader: true
	};
};
